import React from 'react';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
import Card, { LigneCard } from '../../Card';
import Chargement from '../../Chargement';
import { estEnCoursDeChargement } from '../../../App_Code/Utils';


const CardPaiementVirement = ({
    Banques, Cop, Pro, setChoix,
}) => {
    if (estEnCoursDeChargement(Banques)) return <Chargement titreCard="Compte bancaire de la copropriété" />;
    if (Banques.length === 0) return null;
    const Banque = Banques.find(banque => banque.Compte && banque.Compte.Code === 'BNQ');
    const pasDeCompte = !Banque || !Banque.Compte || !Banque.Rib;

    return (
        <Card Titre="Paiement par virement">
            <p>
                Rappelez les références <strong>{Cop.Ind.Code} - {Pro.Ind.Code}</strong> dans le libellé du virement.
            </p>
            { pasDeCompte
                ? <i>Il n&apos;y a pas de compte principal pour cette copropriété. Le mode de paiement par virement n&apos;est donc pas possible.</i>
                :
                <React.Fragment>
                    <LigneCard titre="Intitulé" valeur={Banque.Compte.Nom} />
                    <LigneCard titre="IBAN" valeur={Banque.Rib.Iban} classeValeur="font-weight-bold" />
                    <LigneCard titre="BIC" valeur={Banque.Rib.Bic} derniereLigne />
                    <LigneCard titre="Titulaire" valeur={Banque.Rib.NomSurRIB} />
                </React.Fragment>
            }
            <LigneCard valeur={
                <button onClick={() => { setChoix(0); }} className="btn btn-outline-danger w-25 mt-3">
                    Retour
                </button>}
            />
        </Card>
    );
};
CardPaiementVirement.displayName = 'CardPaiementVirement';
CardPaiementVirement.requiredProps = [
    'Banques', // Banques de la copro
    'Pro', // info du propriétaire
    'Cop', // info de la copropriété
];

function mapStateToProps({
    CopStore: { Banques },
    ProStore: { Pro },
    CopStore: { Cop },
}) {
    return { Banques, Cop, Pro };
}

export default connect(mapStateToPropsWrapper(mapStateToProps))(verificationProps(CardPaiementVirement));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Paiement/CardPaiementVirement.js